import { includes } from 'lodash';

const noSchemasOrAllFieldsAreFilled = (schemas = [], values = []) => {
  if (!schemas.length) return true;

  return schemas.reduce((allFilled, field) => {
    return allFilled && includes(values.map(v => v.schemaId), field.id);
  }, true);
};

export default noSchemasOrAllFieldsAreFilled;



// WEBPACK FOOTER //
// ./src/lib/no-schemas-or-all-fields-are-filled.js